import { useQuery } from '@tanstack/react-query'
import type { BoardGeometry } from '@/shared/board/types'
import { geometry } from '@/shared/engine/board'
import { relayout } from './layout'
import { useBoardKind } from './useBoardKind'

/**
 * Геометрия доски.
 *
 * Считается здесь же, а не запрашивается у сервера: партия за одним
 * устройством должна рисоваться и без сети, а доска — единственное, чего ей
 * для этого не хватало. Совпадение с сервером доказывает золотой корпус
 * (features/engine/golden.test.ts), так что второго источника правды из
 * этого не получается.
 *
 * Обёрткой useQuery, а не голым вызовом: экран партии ждёт от неё состояние
 * запроса, а ручка GET /board остаётся — ею пользуются другие клиенты.
 *
 * Выбранный вид поля (features/board/layout) применяется здесь же и входит
 * в ключ запроса: переключение вида должно пересчитать доску, а не отдать
 * закешированную. Правила от вида не зависят — меняются только координаты
 * клеток, — поэтому дальше по экрану ничего об этом знать не нужно.
 */
export function useBoard() {
  const kind = useBoardKind()

  return useQuery({
    queryKey: ['board', kind],
    queryFn: async (): Promise<BoardGeometry> => relayout(geometry(), kind),
    staleTime: Number.POSITIVE_INFINITY,
    gcTime: Number.POSITIVE_INFINITY,
  })
}
